.h3 {
  display: inline-block;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.78;
  letter-spacing: normal;
  text-align: left;
  color: var(--color-easil-black);
}
